import { render, staticRenderFns } from "./Fundvalue.vue?vue&type=template&id=35165923&scoped=true"
import script from "./Fundvalue.vue?vue&type=script&lang=js"
export * from "./Fundvalue.vue?vue&type=script&lang=js"
import style0 from "./Fundvalue.vue?vue&type=style&index=0&id=35165923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35165923",
  null
  
)

export default component.exports